import React, {Component} from 'react';
import axios from "axios";
import '../spinner.css'

export class Iframe extends Component {
    static displayName = Iframe.name;

    constructor(props) {
        super(props);
        this.state = {
            error: false,
            isLoading: true,
            iframe: null,
            loggedIn: false,
        };
        window.addEventListener("message", async (event) => {
            if (event && event.data && event.data.result && event.data.result === 'success') {
                const result = {
                    loggedIn: true
                };
                if (event.data.legacyToken) {
                    result.appToken = event.data.legacyToken;
                }
                this.setState(result);
            }
        }, false);
    }

    async componentDidMount() {
        const {businessId, priceId} = this.props;
        let result = await this.getAppToken(businessId, priceId);
        const {appToken, url} = result;
        const iframe = `${url}?locationid=${businessId}&token=${appToken}&postMessage=true&priceId=${priceId}`;
        this.setState(
            {
                appToken,
                iframe,
            });
    }

    async getAppToken(businessId, priceId) {
        let result;
        try {
            result = await axios.get(`/api/StripeMember/iframe`, {
                params: {
                    businessId,
                    priceId
                }
            });
            return result.data;
        } catch (e) {
            console.error("error");
            this.setState({error: true});
        }
    }

    render() {
        const {businessId, priceId} = this.props;
        const {appToken, loggedIn, iframe, error} = this.state;
        if (loggedIn) {
            window.location.href = window.location.origin + '?businessId=' + businessId + '&priceId=' + priceId +'&appToken=' + appToken;
            return (<div className="loader"/>);
        }
        return (
            <div>
                {error ? <div>Sorry, an error occured</div> : <div className="loader"/>
                }
                {iframe !== null &&
                <iframe src={iframe}
                        style={{
                            position: 'fixed', top: 0, left: 0, bottom: 0, right: 0, width: "100%", height: "100%",
                            border: 'none', margin: 0, padding: 0, overflow: "hidden", zIndex: 999999
                        }}/>
                }
            </div>
        );
    }
}
